import React from 'react';
import classNames from 'classnames';
import { useRouteMatch } from 'react-router';
import { Redirect, Route, Switch } from 'react-router-dom';

import { SetupForm } from './SetupForm/SetupForm';

import css from './FbConversionsApi.module.css';
import { SlideoutMenu } from '../../../../components/SlideoutMenu/components/SlideoutMenu';
import { CloseOutlined } from '@ant-design/icons';
import { useSlideoutOnClose } from '../../../../components/SlideoutMenu/menus/SlideoutEmail/SlideoutEmail';
import { useViewActions } from '@mm/state/actions/viewActions';

type Props = {
  className?: string;
};

export const FBConversionsApi = ({ className }: Props) => {
  const match = useRouteMatch<{ id?: string; chatbotId: string }>();
  const containerClassName = classNames(className, css.container);

  const { setRef } = useSlideoutOnClose();
  const { hideSlideoutMenu } = useViewActions();

  const closeSlideout = async () => {
    hideSlideoutMenu();
  };

  return (
    <SlideoutMenu className={css.menu} setRef={setRef}>
      <div className={css.headerContent}>
        <CloseOutlined onClick={closeSlideout} className={css.closeIcon} />
      </div>
      <SlideoutMenu.Content className={css.content}>
        <SetupForm />
      </SlideoutMenu.Content>
    </SlideoutMenu>
  );
};
